import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

interface UploadBoxProps {
  $isDragging: boolean
}

export const Container = styled.div`
  width: 100%;
  max-width: 1000px;
`

export const UploadBox = styled.div<UploadBoxProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 32px;
  border: 2px dashed ${({ $isDragging }) => ($isDragging ? Tokens.ColorUIPrimary : Tokens.ColorBorder)};
  border-radius: 12px;
  transition: all 0.2s ease;
`

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: ${Tokens.ColorUIPrimary};
  line-height: 0;
`

export const UploadIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${Tokens.ColorBackground};
  color: ${Tokens.ColorTextSecondary};
  flex-shrink: 0;
`

export const UploadContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const UploadTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
  margin: 0;
`

export const UploadDescription = styled.p`
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  margin: 0;
  line-height: 1.5;
`

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  color: ${Tokens.ColorUIPrimary};
`

export const SelectedFile = styled.div`
  font-size: 13px;
  color: ${Tokens.ColorUIPrimary};
  margin-top: 4px;

  strong {
    font-weight: 600;
  }
`

export const BrowseButton = styled.button`
  padding: 10px 20px;
  background-color: white;
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 8px;
  color: ${Tokens.ColorTextPrimary};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
`

export const HiddenInput = styled.input`
  display: none;
`

export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${Tokens.ColorTextSecondary};

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid ${Tokens.ColorBorder};
  }

  &::before {
    margin-right: 24px;
  }

  &::after {
    margin-left: 24px;
  }
`

export const HelperList = styled.ul`
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  color: ${Tokens.ColorTextSecondary};
  line-height: 1.6;
`

export const HelperListItem = styled.li`
  margin-bottom: 2px;

  strong {
    color: ${Tokens.ColorTextPrimary};
    font-weight: 600;
  }
`
